/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AddEntityUser201,
  AddEntityUserBody,
  EntityUser,
  EntityUsersList,
  Error,
  GenerateUserTokenResponse,
  RemoveEntityUser200,
  UpdateEntityUserRoleBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve all users who have access to the current entity, including their roles.
 * @summary List entity users
 */
export type getEntityUsersResponse200 = {
  data: EntityUsersList
  status: 200
}

export type getEntityUsersResponse400 = {
  data: Error
  status: 400
}

export type getEntityUsersResponse401 = {
  data: Error
  status: 401
}

export type getEntityUsersResponse403 = {
  data: Error
  status: 403
}

export type getEntityUsersResponse404 = {
  data: Error
  status: 404
}

export type getEntityUsersResponse500 = {
  data: Error
  status: 500
}

export type getEntityUsersResponseSuccess = (getEntityUsersResponse200) & {
  headers: Headers;
};
export type getEntityUsersResponseError = (getEntityUsersResponse400 | getEntityUsersResponse401 | getEntityUsersResponse403 | getEntityUsersResponse404 | getEntityUsersResponse500) & {
  headers: Headers;
};

export type getEntityUsersResponse = (getEntityUsersResponseSuccess | getEntityUsersResponseError)

export const getGetEntityUsersUrl = () => {


  

  return `/entities/users`
}

export const getEntityUsers = async ( options?: RequestInit): Promise<getEntityUsersResponse> => {
  
  return customFetch<getEntityUsersResponse>(getGetEntityUsersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Add an existing user to the entity or send an invitation to a new user. If the user exists, they are immediately granted access. If not, an invitation email is sent.
 * @summary Add user to entity
 */
export type addEntityUserResponse201 = {
  data: AddEntityUser201
  status: 201
}

export type addEntityUserResponse400 = {
  data: Error
  status: 400
}

export type addEntityUserResponse401 = {
  data: Error
  status: 401
}

export type addEntityUserResponse403 = {
  data: Error
  status: 403
}

export type addEntityUserResponse404 = {
  data: Error
  status: 404
}

export type addEntityUserResponse422 = {
  data: ValidationError
  status: 422
}

export type addEntityUserResponse500 = {
  data: Error
  status: 500
}

export type addEntityUserResponseSuccess = (addEntityUserResponse201) & {
  headers: Headers;
};
export type addEntityUserResponseError = (addEntityUserResponse400 | addEntityUserResponse401 | addEntityUserResponse403 | addEntityUserResponse404 | addEntityUserResponse422 | addEntityUserResponse500) & {
  headers: Headers;
};

export type addEntityUserResponse = (addEntityUserResponseSuccess | addEntityUserResponseError)

export const getAddEntityUserUrl = () => {


  

  return `/entities/users`
}

export const addEntityUser = async (addEntityUserBody: AddEntityUserBody, options?: RequestInit): Promise<addEntityUserResponse> => {
  
  return customFetch<addEntityUserResponse>(getAddEntityUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addEntityUserBody,)
  }
);}
  

/**
 * Update a user's role on the entity. Roles: viewer (read-only), editor (read+write), admin (full access).
 * @summary Update user role
 */
export type updateEntityUserRoleResponse200 = {
  data: EntityUser
  status: 200
}

export type updateEntityUserRoleResponse400 = {
  data: Error
  status: 400
}

export type updateEntityUserRoleResponse401 = {
  data: Error
  status: 401
}

export type updateEntityUserRoleResponse403 = {
  data: Error
  status: 403
}

export type updateEntityUserRoleResponse404 = {
  data: Error
  status: 404
}

export type updateEntityUserRoleResponse422 = {
  data: ValidationError
  status: 422
}

export type updateEntityUserRoleResponse500 = {
  data: Error
  status: 500
}

export type updateEntityUserRoleResponseSuccess = (updateEntityUserRoleResponse200) & {
  headers: Headers;
};
export type updateEntityUserRoleResponseError = (updateEntityUserRoleResponse400 | updateEntityUserRoleResponse401 | updateEntityUserRoleResponse403 | updateEntityUserRoleResponse404 | updateEntityUserRoleResponse422 | updateEntityUserRoleResponse500) & {
  headers: Headers;
};

export type updateEntityUserRoleResponse = (updateEntityUserRoleResponseSuccess | updateEntityUserRoleResponseError)

export const getUpdateEntityUserRoleUrl = (userId: string,) => {


  

  return `/entities/users/${userId}`
}

export const updateEntityUserRole = async (userId: string,
    updateEntityUserRoleBody: UpdateEntityUserRoleBody, options?: RequestInit): Promise<updateEntityUserRoleResponse> => {
  
  return customFetch<updateEntityUserRoleResponse>(getUpdateEntityUserRoleUrl(userId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEntityUserRoleBody,)
  }
);}
  

/**
 * Remove a user's access to the entity. This does not delete the user account.
 * @summary Remove user from entity
 */
export type removeEntityUserResponse200 = {
  data: RemoveEntityUser200
  status: 200
}

export type removeEntityUserResponse400 = {
  data: Error
  status: 400
}

export type removeEntityUserResponse401 = {
  data: Error
  status: 401
}

export type removeEntityUserResponse403 = {
  data: Error
  status: 403
}

export type removeEntityUserResponse404 = {
  data: Error
  status: 404
}

export type removeEntityUserResponse422 = {
  data: ValidationError
  status: 422
}

export type removeEntityUserResponse500 = {
  data: Error
  status: 500
}

export type removeEntityUserResponseSuccess = (removeEntityUserResponse200) & {
  headers: Headers;
};
export type removeEntityUserResponseError = (removeEntityUserResponse400 | removeEntityUserResponse401 | removeEntityUserResponse403 | removeEntityUserResponse404 | removeEntityUserResponse422 | removeEntityUserResponse500) & {
  headers: Headers;
};

export type removeEntityUserResponse = (removeEntityUserResponseSuccess | removeEntityUserResponseError)

export const getRemoveEntityUserUrl = (userId: string,) => {


  

  return `/entities/users/${userId}`
}

export const removeEntityUser = async (userId: string, options?: RequestInit): Promise<removeEntityUserResponse> => {
  
  return customFetch<removeEntityUserResponse>(getRemoveEntityUserUrl(userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Generate an access token for a WL user to enable SSO-like redirect. This allows account admins to redirect users to the web app without requiring them to login.
 * @summary Generate user access token
 */
export type generateEntityUserTokenResponse200 = {
  data: GenerateUserTokenResponse
  status: 200
}

export type generateEntityUserTokenResponse400 = {
  data: Error
  status: 400
}

export type generateEntityUserTokenResponse401 = {
  data: Error
  status: 401
}

export type generateEntityUserTokenResponse403 = {
  data: Error
  status: 403
}

export type generateEntityUserTokenResponse404 = {
  data: Error
  status: 404
}

export type generateEntityUserTokenResponse422 = {
  data: ValidationError
  status: 422
}

export type generateEntityUserTokenResponse500 = {
  data: Error
  status: 500
}

export type generateEntityUserTokenResponseSuccess = (generateEntityUserTokenResponse200) & {
  headers: Headers;
};
export type generateEntityUserTokenResponseError = (generateEntityUserTokenResponse400 | generateEntityUserTokenResponse401 | generateEntityUserTokenResponse403 | generateEntityUserTokenResponse404 | generateEntityUserTokenResponse422 | generateEntityUserTokenResponse500) & {
  headers: Headers;
};

export type generateEntityUserTokenResponse = (generateEntityUserTokenResponseSuccess | generateEntityUserTokenResponseError)

export const getGenerateEntityUserTokenUrl = (userId: string,) => {


  

  return `/entities/users/${userId}/token`
}

export const generateEntityUserToken = async (userId: string, options?: RequestInit): Promise<generateEntityUserTokenResponse> => {
  
  return customFetch<generateEntityUserTokenResponse>(getGenerateEntityUserTokenUrl(userId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

